import axios from 'axios'

// Get all tickets book
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/business-ticket-book`)
  return data
}

// Create tickets book
const create = async (
  seats,
  ticketType,
  blocked
) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/business-ticket-book`, {
    seats,
    ticketType,
    blocked
  })
  return data
}

// Remove tickets book
const remove = async (seats) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/business-ticket-book`, { data: { seats } })
  return data
}

export {
  getAll,
  create,
  remove
}
